import React, { useState } from "react";
import { Card, TextField, Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { useForm } from "react-hook-form";
import axios from 'axios';
import { useNotify } from "react-admin";
import { getReserveList, changeStatusReserveDiet ,transferReservedDiet} from './index';

export const validateIranMobile = (value:any) => {
    const regex = /^09\d{9}$/;
    if (value) {
        if (!regex.test(value)) {
            return "شماره موبایل صحیح نمیباشد";
        }
        return true;
    }
};

const ListComponent = ({ items, refreshList }:any) => {
    const notify = useNotify();
    const formatDate = (date:any) => {
        return new Intl.DateTimeFormat("fa-IR", {
            weekday: "long",
            year: "numeric",
            month: "numeric",
            day: "numeric",
        }).format(new Date(date));
    };
    const [loadingStates, setLoadingStates] = useState(Array(items.length).fill(false));
    const [loadingStates2, setLoadingStates2] = useState(Array(items.length).fill(false));
    const [modalOpen, setModalOpen] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(null);
    const { register, handleSubmit, formState: { errors, isValid }, reset } = useForm({
        mode: "onChange",
    });

    const setLoadingState = (index:any, value:any) => {
        setLoadingStates(prevStates => {
            const newStates = [...prevStates];
            newStates[index] = value;
            return newStates;
        });
    };
    const setLoadingState2 = (index:any, value:any) => {
        setLoadingStates2(prevStates => {
            const newStates = [...prevStates];
            newStates[index] = value;
            return newStates;
        });
    };
    const setDisable = async (itemIndex:any) => {
        setLoadingState2(itemIndex, true);
        const params = { id: items[itemIndex].diets[0].id, status: "CANCELLED" }
        changeStatusReserveDiet(params).then((res) => {
            if (res.data.err) {
                if (res.data.err.code === 400 && res.data.err.message === "user-has-active-diet") {
                    
                    notify("کاربر رژیم فعال دارد", { type: 'error' })

                }else if(res.data.err.code === 400 && res.data.err.message === "invalid-reserved-diet"){
                    notify(" رژیم  رزرو  یافت نشد", { type: 'error' })

                }else if(res.data.err.code === 500){
                    notify(" ۵۰۰ خطای سرور  ", { type: 'error' })

                }else{
                    notify("خطایی پیش آمده است ", { type: 'error' })
                }   
               
                setLoadingState2(itemIndex, false)
            }
            else {
                if (res.data) {
                    console.log("res", res.data);
                    setLoadingState2(itemIndex, false)
                    notify("با موفقیت انجام شد", { type: 'success' })
                    refreshList()
                }
            }
        }).catch((err) => {

            setLoadingState2(itemIndex, false)
            notify("خطایی پیش آمده است ", { type: 'error' })
        })

    };
    const setEnable = async (itemIndex:any) => {
        setLoadingState(itemIndex, true);
        const params = { id: items[itemIndex].diets[0].id, status: "CREATED" };
        changeStatusReserveDiet(params).then((res) => {
            if (res.data.err) {
                console.log("err", res.data.err);
                notify("خطایی پیش آمده است ", { type: 'error' });
                refreshList();
                setLoadingState(itemIndex, false);
            } else {
                if (res.data) {
                    console.log("res", res.data);
                    setLoadingState(itemIndex, false);
                    notify("با موفقیت انجام شد", { type: 'success' });
                    refreshList();
                }
            }
        }).catch((err) => {
            setLoadingState(itemIndex, false);
            notify("خطایی پیش آمده است ", { type: 'error' });
        });
    };

    const transferReserveDiet = (index:any) => {
        setCurrentIndex(index);
        setModalOpen(true);
    };

    const handleModalClose = () => {
        setModalOpen(false);
        reset();
    };

    const onSubmit =async (data:any) => {
        const postData = {
            index: currentIndex,
            mobile: data.mobile
        };
        try {
            const res = await transferReservedDiet(postData)
            if (res.data.err) {
                notify(res.data.err.details.messages[0], { type: 'error' });
                handleModalClose();
             } else {
                 if (res.data) {
                     handleModalClose();
                     notify("انتقال با موفقیت انجام شد", { type: 'success' });
                 }
             } 
        } catch (error) {
            handleModalClose();
            notify("خطایی پیش آمده است ", { type: 'error' });
        }
       
    };

    return (
        <div style={{
            display: "flex",
            flexWrap: "wrap",
            marginTop: "1rem",
            width: "100%",
            direction: "rtl",
            fontFamily: "IranSans-Medium"
        }}>
            {items.map((item:any, index:any) => (
                <Card key={index} style={{ padding: "20px",margin:"20px", position: 'relative' }}>
                    <div style={{ margin: "8px" }}>عنوان: <span style={{ color: "dimgray" }}>{item.meta.title} </span></div>
                    <div style={{ margin: "8px" }}>تاریخ ایجاد: <span style={{ color: "dimgray" }}> {item.createdAt ? formatDate(item.createdAt) : ''}</span></div>
                    <div style={{ margin: "8px" }}>تعداد دوره: <span style={{ color: "dimgray" }}> {item.dietCount}</span></div>
                    <div style={{ margin: "8px" }}>لیموپلاس: <span style={{ color: "dimgray" }}>{item.meta.withMentor ? 'دارد' : 'ندارد'}</span></div>
                    <Button disabled={loadingStates[index]} style={{ color: '#fff', marginTop: '10px' }} onClick={() => setEnable(index)} variant="contained" color="primary">
                        {loadingStates[index] ? 'در حال فعال‌سازی...' : 'فعال سازی'}
                    </Button>
                    <Button disabled={loadingStates2[index]} style={{ color: '#fff', marginTop: '10px', marginRight: "5px" }} onClick={() => setDisable(index)} variant="contained" color="secondary">
                        {loadingStates2[index] ? 'در حال غیرفعال سازی...' : 'غیر فعال سازی'}
                    </Button>
                    <Button style={{ color: '#fff', marginTop: '10px',marginRight: "5px" }} onClick={() => transferReserveDiet(item.id)} variant="contained" color="primary">
                        انتقال
                    </Button>
                </Card>
            ))}
            <Dialog open={modalOpen} maxWidth={"md"}  fullWidth={true} onClose={handleModalClose}>
                <DialogTitle>انتقال</DialogTitle>
                <DialogContent  style={{ overflow: 'hidden  ', maxHeight: '80vh' }}>
                    <form onSubmit={handleSubmit(onSubmit)} style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                        <TextField
                            {...register("mobile", { validate: validateIranMobile })}
                            error={!!errors.mobile}
                            helperText={errors.mobile ? errors.mobile.message : null}
                            fullWidth
                            label="شماره موبایل"
                            placeholder="09*********"
                            variant="outlined"
                        />
                        <DialogActions style={{display:"flex",justifyContent:"start"}} >
                        <Button type="submit" color="primary" style={{color:"#fff"}} variant="contained" disabled={!isValid}>
                                تایید
                            </Button>
                            <Button onClick={handleModalClose} style={{marginRight:"5px"}} variant="contained" color="secondary">
                                لغو
                            </Button>
                        
                        </DialogActions>
                    </form>
                </DialogContent>
            </Dialog>
        </div>
    );
};

export function ListReserveManagement() {
    const { register, handleSubmit, formState: { errors, isValid } } = useForm({
        mode: "onChange",
        defaultValues: {
            mobile: null,
        },
    });
    const [errorMessages, setErrorMessages] = useState<any>([]);
    const [networkState, setNetworkState] = useState("IDLE");
    const [reserveList, setReserveList] = useState([]);
    const [userMobile, setUserMobile] = useState("");

    const refreshList = () => {
        onSubmit({ mobile: userMobile });
    };

    const onSubmit = async (data:any) => {
        setReserveList([]);
        setErrorMessages([]);
        setNetworkState("PENDING");
        setUserMobile(data.mobile);
        const postData = {
            mobile: data.mobile,
        };

        getReserveList(postData).then((res) => {
            if (res.data.err) {
                
                setErrorMessages([res.data.err.details.messages[0]]);
                setNetworkState("FAILED");
            } else {
                if (res.data) {
                    setNetworkState("SUCCEED");
                    setReserveList(res.data);
                }
            }
        }).catch((err) => {
            console.log('err', err);
        });
    };

    return (
        <>
            <Card>
                <form
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "1rem",
                        margin: "3rem",
                        direction: "rtl",
                    }}
                    onSubmit={handleSubmit(onSubmit)}
                >
                    <TextField
                        {...register("mobile", { validate: validateIranMobile })}
                        error={!!errors.mobile}
                        helperText={errors.mobile ? errors.mobile.message : null}
                        fullWidth
                        label="شماره موبایل "
                        placeholder="09*********"
                        variant="outlined"
                    />

                    <Button
                        disabled={!isValid || networkState === "PENDING"}
                        fullWidth
                        type="submit"
                        color="primary"
                        style={{ color: "#fff" }}
                        variant="contained"
                    >
                        لیست رزرو ها
                    </Button>

                    {networkState === "SUCCEED" && <p>   </p>}
                    {networkState === "PENDING" && <p>در حال ارسال اطلاعات ...</p>}
                    {networkState === "FAILED" &&
                        (errorMessages.length > 0 ? <p>{errorMessages[0]}</p> : <div>خطایی رخ داده است</div>)}
                </form>
            </Card>
            <ListComponent items={reserveList} refreshList={refreshList} />
        </>
    );
}